import { render, staticRenderFns } from "./EditSidenav.vue?vue&type=template&id=20a185b5"
import script from "./EditSidenav.vue?vue&type=script&lang=js"
export * from "./EditSidenav.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports